import { Suspense, useMemo, useState } from 'react';
import { FormFiltersActualizacionInterface, GenerarArchivoRequest, SeleccionMutuo } from '../interfaces';
import { useColumnsActualizacionDeuda } from '../utils';
import { useDataFetch } from '../../../../hooks/useDataFetch2';
import CustomAccordion from '../../../../components/ui/materialui/customAccordion';
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { exportExcel } from '../../../../utils/exportExcel';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Grid2 } from '@mui/material';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { descargarArchivoActualizacionPortabilidad } from '../../../detalleMutuo/services/servicesReportes';
import { TipoFuncionalidad } from '../../../../utils/enums';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';

const urlTabla = `siscred-api-reportes/v1/portabilidad/obtener-productos-act`;

interface TableComponentInterface {
    formFilters: FormFiltersActualizacionInterface,
}

export const TablaComponent = ({ formFilters }: TableComponentInterface) => {

    const params = useMemo(() => {
        const p = new URLSearchParams();
        p.set("idSol", String(formFilters.idSolicitud));
        p.set("idOpe", String(formFilters.idOperacion));
        p.set("tipoCert", "ACTUALIZACION");
        return p;
    }, [formFilters]);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const [idsMutuos, setIdsMutuos] = useState<string[]>([]);

    const { COLUMNS } = useColumnsActualizacionDeuda({ controlTabla: dataTable, idsMutuos, setIdsMutuos });
    const columns = useMemo(() => COLUMNS, [dataTable, idsMutuos]);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => { },
    });

    const modalConfirmGeneracion = () => {
        setModalConfirmacion({
            show: true,
            title: 'Generar Certificado de Actualización de Deuda',
            message: '¿Está seguro de querer generar el certificado?',
            metodo: generarCertificado,
        });
    };

    const generarCertificado = async () => {
        const rows = (dataTable?.data ?? []) as any[];

        const byId = new Map(
            rows
                .filter(r => r?.numerooperacionmutuo)
                .map(r => [String(r.numerooperacionmutuo), r])
        );

        // Construimos el payload solicitado
        const payload: SeleccionMutuo[] = idsMutuos.map(id => {
            const r = byId.get(id);
            return {
                numeroOperacion: id,
                idComplementario: String(r?.numerooperacionmutuocomple ?? "")
            };
        });

        const body: GenerarArchivoRequest = {
            idSolicitudPortabilidad: Number(formFilters.idSolicitud),
            idOperacionPortabilidad: Number(formFilters.idOperacion),
            rutCliente: formFilters.rutCliente!,
            mutuosSeleccionados: payload,
        }

        await descargarArchivoActualizacionPortabilidad(body);
    };

    return (
        <CustomAccordion title={'Productos'} expandedDefault>
            <Suspense>
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({
                            ...modalConfirmacion,
                            show: false,
                        })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    show={modalConfirmacion.show}
                    title={modalConfirmacion.title}
                    message={modalConfirmacion.message}
                />

                <Tabla
                    columns={columns}
                    control={dataTable}
                    url={urlTabla}
                    titulo={
                        <>
                            <TableHeader
                                title=""
                                control={dataTable}
                                button={
                                    <Grid2 container spacing={1} sx={{ justifyContent: "flex-end", textAlign: "right" }}>
                                        <MButton
                                            type="button"
                                            variant='contained'
                                            color='primary'
                                            disabled={idsMutuos.length ? false : true}
                                            onClick={modalConfirmGeneracion}
                                        >
                                            Generar Certificado
                                        </MButton>
                                    </Grid2>
                                }
                                buttonExport={
                                    <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                        <MButton
                                            type="button"
                                            variant="outlined"
                                            onClick={() => exportExcel(dataTable.data, columns, "Productos")}
                                            startIcon={<SummarizeTwoToneIcon />}
                                        >
                                            Exportar
                                        </MButton>
                                    </PermissionGuard>
                                }
                            />
                        </>
                    }
                />
            </Suspense>
        </CustomAccordion>
    )
};